(ns frontend.exports.exceljs.number-formats
  (:require [frontend.utils :as fu]))

(defn two-decimal-number [thousand-separator decimal-separator]
  (fu/format "#%s###%s##" thousand-separator decimal-separator))

(def two-decimal-period-comma (two-decimal-number "." ","))
(def two-decimal-space-comma (two-decimal-number " " ","))
(def two-decimal-comma-period (two-decimal-number "," "."))

(def thousands-space "# ###")

(def two-decimal-percentage-comma "0,00%")
(def two-decimal-percentage-period "0.00%")
(def date-m-d-yyyy-slash "m/d/yyyy")
(def date-d-m-yyyy-point "d.m.yyyy")
(def date-d-m-yyyy "d-m-yyyy")

